import {
  FORMEDIT_FORM_MODAL_CHANGE,
} from './constants';

export function formModalChange(visible,type) {
  return {
    type: FORMEDIT_FORM_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FORMEDIT_FORM_MODAL_CHANGE:
      return {
        ...state,
        formModalType:action.data.type,
        formModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/formedit/redux/formModalChange.js